const orderinfo_to_usersearch_cdt = "orderinfo_to_usersearch_cdt";
const userupdate_to_user_close = "userupdate_to_user_close";
const usersearch_to_orderinfoupdate = "usersearch_to_orderinfoupdate";
const orderinfoupdate_to_orderinfo_close = "orderinfoupdate_to_orderinfo_close";
const percentageupdate_to_percentage_close = "percentageupdate_to_percentage_close";
const percentagesearch_to_orderinfoupdate = "percentagesearch_to_orderinfoupdate";
const percentagesearch_to_orderinfoupdate_close = "percentagesearch_to_orderinfoupdate_close";
const userupdate_to_userlist_close = "userupdate_to_userlist_close";


export default {
    orderinfo_to_usersearch_cdt,
    userupdate_to_user_close,
    usersearch_to_orderinfoupdate,
    orderinfoupdate_to_orderinfo_close,
    percentageupdate_to_percentage_close,
    percentagesearch_to_orderinfoupdate,
    percentagesearch_to_orderinfoupdate_close,
    userupdate_to_userlist_close,
}